/*
 * Created by alex@hackerbay.com on 21.12.2018
 * Copyright Singularity Technologies GmbH (c) 2018. All rights reserved
 */

import * as React from "react";
import '../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import {translate} from "react-i18next";
import i18n from "i18next";
import {Button, Card, CardBody, Col, Row} from "reactstrap";
import Subtitle from "./Subtitle";

import iconVodafoneWarning from "../media/icons/vf-warning.png"
import iconVodafoneInfo from "../media/icons/vf-info.png"
import DownloadCalendarFileLink from "../pages/DownloadCalendarFileLink";


class InfoBox extends React.Component {
    constructor(props){
        super(props);
    }

    render() {
        let button = "";
        if(this.props.buttonOnClick){
            button = <a onClick={this.props.buttonOnClick}><u>{i18n.t(this.props.buttonTextResource, this.props)}</u></a>;
        }else if(this.props.showCalendarLink){
            button = <DownloadCalendarFileLink
                text={i18n.t(this.props.buttonTextResource, this.props)}
                urlIdent={this.props.urlIdent}
            />
        }

        let cardClass = "card-info";
        let cardIcon = iconVodafoneInfo;
        if(this.props.cardType === "warning"){
            cardClass = "card-warning";
            cardIcon = iconVodafoneWarning
        }


        return <Row>
            <Col>
                <Card className={cardClass}>
                    <CardBody>
                        <Row>
                            <Col xs={2} style={{paddingLeft:"5px",paddingRight:"20px"}}>
                                <img
                                    alt={this.props.textResource}
                                    src={cardIcon}
                                    className={"img-fluid"}
                                />
                            </Col>
                            <Col xs={10} style={{paddingLeft:"0px"}}>
                                <p>{i18n.t(this.props.textResource, this.props)}</p>
                                {button}
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            </Col>
        </Row>
    }
}

export default translate("translations")(InfoBox);